import { OrderBookingMode, OrderType } from '@vista-digital/ocapi-types/v1';
import { getOrderBookingMode } from '../order/get-order-booking-mode';
import { getOrderType } from '../order/get-order-type';
import { getOrderUnpaidBalance } from './get-order-unpaid-balance';
export const orderRequiresPayment = () => {
    const hasUnpaidBalance = getOrderUnpaidBalance() > 0;
    const isUnpaidBooking = getOrderType() === OrderType.Standard && getOrderBookingMode() !== OrderBookingMode.Paid;
    return hasUnpaidBalance && !isUnpaidBooking;
};
